<div class="admin-page-title">
  <eps-button
    class="edit-button"
    (buttonClick)="cancelClicked.emit()"
    label="SHARED.BUTTONS.BACK"
  ></eps-button>
  <div class="content">
    <app-title
      *ngIf="isEdit"
      title="ADMIN.SHARED.EDIT"
      subtitle="ADMIN.SHARED.EPSUSER"
    ></app-title>
    <app-title
      *ngIf="isInvitation"
      title="ADMIN.SHARED.INVITE"
      subtitle="ADMIN.SHARED.EPSUSER"
    ></app-title>
    <app-title
      *ngIf="isCreate"
      title="ADMIN.SHARED.CREATE"
      subtitle="ADMIN.SHARED.EPSUSER"
    ></app-title>
  </div>
</div>

<div
  class="button-container row"
  *ngIf="isEdit"
>
  <div class="col-12 col-md-12 col-lg-9">
    <div
      class="buttons"
      @easeInOut
      *ngIf="userContext.adminRoles.reInvite && !user.invitationAccepted"
    >
      <eps-button
        label="ADMIN.SHARED.RE_INVITE"
        buttonIcon="envelope-o"
        [disabled]="reInviting || buttonIsDisabled()"
        [busy]="reInviting"
        *ngIf="userContext.adminRoles.reInvite"
        (buttonClick)="!buttonIsDisabled() && reInvite.emit(user.id)"
      ></eps-button>
    </div>
  </div>
</div>

<div class="filter-container row">
  <div class="filter-container-inner col-12 col-md-12 col-lg-9">
    <form
      class="userForm"
      [formGroup]="userForm"
    >
      <eps-text-input
        label="ADMIN.EPS_USERS.NAME"
        formControlName="firstName"
        [readonly]="isView"
        [disabled]="saving"
      ></eps-text-input>

      <eps-text-input
        label="ADMIN.EPS_USERS.LAST_NAME"
        formControlName="lastName"
        [readonly]="isView"
        [disabled]="saving"
      ></eps-text-input>

      <eps-text-input
        label="ADMIN.EPS_USERS.EMAIL"
        formControlName="email"
        [disabled]="saving"
        *ngIf="isInvitation"
      ></eps-text-input>

      <eps-label-body
        label="ADMIN.EPS_USERS.EMAIL"
        *ngIf="isEdit"
      >
        <div class="email-with-copybutton">
          <eps-text-input
            formControlName="email"
            labelPosition="none"
            [readonly]="true"
            [disabled]="saving"
          ></eps-text-input>
          <i
            class="fa fa-clipboard"
            ngxClipboard
            [cbContent]="user.email"
            (click)="copyToClipboard()"
            *ngIf="isEdit || isView"
          ></i>
          <div
            class="mat-tooltip"
            *ngIf="cbFeedback"
          >
            {{ 'ADMIN.SHARED.COPIED' | translate }}
          </div>
        </div>
      </eps-label-body>

      <eps-select
        formControlName="language"
        label="ADMIN.CLIENT_USERS.LANGUAGE"
        [options]="adminDefinitions.language"
        [readonly]="isView"
        [disabled]="saving"
        hideOptionalMarker
      ></eps-select>

      <eps-checkbox
        class="edit"
        formControlName="isAdmin"
        label="ADMIN.EPS_USERS.ADMIN"
        [readonly]="isView || user.isAgent"
        [disabled]="saving"
        useIconsInReadonly
        hideOptionalMarker
      ></eps-checkbox>

      <div
        class="row admin-options"
        *ngIf="userForm.value.isAdmin"
        @easeInOut
      >
        <div class="col-6">
          <eps-checkbox
            class="edit"
            labelPosition="none"
            checkboxLabel="ADMIN.EPS_USERS.UPDATE_CLIENT_USER"
            formControlName="updateClientUser"
            [readonly]="isView || user.isAgent"
            [disabled]="saving"
          ></eps-checkbox>

          <eps-checkbox
            class="edit"
            labelPosition="none"
            checkboxLabel="ADMIN.EPS_USERS.UPDATE_EPS_USER"
            formControlName="updateEpsUser"
            [readonly]="isView || user.isAgent"
            [disabled]="saving"
          ></eps-checkbox>

          <eps-checkbox
            class="edit"
            labelPosition="none"
            checkboxLabel="ADMIN.EPS_USERS.RE_INVITE"
            formControlName="reInvite"
            [readonly]="isView || user.isAgent"
            [disabled]="saving"
          ></eps-checkbox>
        </div>
        <div class="col-6">
          <eps-checkbox
            class="edit"
            labelPosition="none"
            checkboxLabel="ADMIN.EPS_USERS.CREATE_CLIENT_USER"
            formControlName="createClientUser"
            hideOptionalMarker
            [readonly]="isView || user.isAgent"
            [disabled]="saving"
          ></eps-checkbox>

          <eps-checkbox
            class="edit"
            labelPosition="none"
            checkboxLabel="ADMIN.EPS_USERS.INVITE_EPS_USER"
            formControlName="inviteEpsUser"
            [readonly]="isView || user.isAgent"
            [disabled]="saving"
          ></eps-checkbox>

          <eps-checkbox
            class="edit"
            labelPosition="none"
            checkboxLabel="ADMIN.EPS_USERS.RESET_PASSWORD"
            formControlName="resetPassword"
            [readonly]="isView || user.isAgent"
            [disabled]="saving"
          ></eps-checkbox>
        </div>
      </div>

      <eps-checkbox
        class="edit"
        formControlName="isActive"
        [readonly]="isView || user.isAgent"
        [disabled]="saving"
        label="ADMIN.CLIENT_USERS.ACTIVE"
        useIconsInReadonly
        hideOptionalMarker
      ></eps-checkbox>

      <eps-checkbox
        formControlName="canRelocate"
        label="ADMIN.EPS_USERS.RELOCATION"
        useIconsInReadonly
        hideOptionalMarker
        [disabled]="saving"
      ></eps-checkbox>

      <eps-checkbox
        formControlName="canSelectDepot"
        label="ADMIN.EPS_USERS.SELECT_DEPOT"
        useIconsInReadonly
        hideOptionalMarker
        [disabled]="saving"
      ></eps-checkbox>

      <eps-checkbox
        formControlName="canUseHiddenMaterials"
        label="ADMIN.EPS_USERS.USE_HIDDEN_MATERIALS"
        useIconsInReadonly
        hideOptionalMarker
        [disabled]="saving"
      ></eps-checkbox>

      <div class="hr-accent"></div>

      <div class="row">
        <div class="col-12">
          <eps-select
            [options]="salesOrganisations"
            formControlName="salesOrganisations"
            label="ADMIN.EPS_USERS.SALES_ORG"
            multiple
            hideOptionalMarker
          ></eps-select>
        </div>
      </div>

      <div class="hr-thick"></div>

      <div
        class="buttons"
        *ngIf="!isView"
      >
        <eps-button
          type="link"
          label="SHARED.BUTTONS.CANCEL"
          [disabled]="saving"
          (buttonClick)="cancelClicked.emit()"
        ></eps-button>
        <eps-button
          type="primary"
          label="ADMIN.SHARED.UPDATE"
          buttonIcon="check"
          [busy]="saving"
          [disabled]="!userForm.valid || buttonIsDisabled() || saving"
          (buttonClick)="_updateUser(userForm.valid)"
          *ngIf="isEdit"
        ></eps-button>
        <eps-button
          type="primary"
          label="ADMIN.SHARED.CREATE"
          buttonIcon="check"
          [busy]="saving"
          [disabled]="!userForm.valid || buttonIsDisabled() || saving"
          (buttonClick)="_createUser(userForm.valid)"
          *ngIf="isCreate"
        ></eps-button>
        <eps-button
          type="primary"
          label="ADMIN.SHARED.INVITE"
          buttonIcon="check"
          [busy]="saving"
          [disabled]="!userForm.valid || buttonIsDisabled() || saving"
          (buttonClick)="_inviteUser(userForm.valid)"
          *ngIf="isInvitation"
        ></eps-button>
      </div>
    </form>
  </div>
</div>
